module.exports = __webpack_public_path__ + "static/media/pupil_app_url_boom.347cee0d.svg";